/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbPatientRequestSummary } from './HchbPatientRequestSummary';
import {
    HchbPatientRequestSummaryFromJSON,
    HchbPatientRequestSummaryFromJSONTyped,
    HchbPatientRequestSummaryToJSON,
    HchbPatientRequestSummaryToJSONTyped,
} from './HchbPatientRequestSummary';

/**
 * 
 * @export
 * @interface CreateHchbPatientRequest201Response
 */
export interface CreateHchbPatientRequest201Response {
    /**
     * 
     */
    data?: HchbPatientRequestSummary;
}

/**
 * Check if a given object implements the CreateHchbPatientRequest201Response interface.
 */
export function instanceOfCreateHchbPatientRequest201Response(value: object): value is CreateHchbPatientRequest201Response {
    return true;
}

export function CreateHchbPatientRequest201ResponseFromJSON(json: any): CreateHchbPatientRequest201Response {
    return CreateHchbPatientRequest201ResponseFromJSONTyped(json, false);
}

export function CreateHchbPatientRequest201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateHchbPatientRequest201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : HchbPatientRequestSummaryFromJSON(json['data']),
    };
}

export function CreateHchbPatientRequest201ResponseToJSON(json: any): CreateHchbPatientRequest201Response {
    return CreateHchbPatientRequest201ResponseToJSONTyped(json, false);
}

export function CreateHchbPatientRequest201ResponseToJSONTyped(value?: CreateHchbPatientRequest201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': HchbPatientRequestSummaryToJSON(value['data']),
    };
}

